function crcTable() {
  let c, crcTable = [];
  for (let n = 0; n < 256; n++) {
    c = n;
    for (let k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
    crcTable[n] = c >>> 0;
  }
  return crcTable;
}
const crcT = crcTable();
function crc32(data) {
  let crc = 0xFFFFFFFF;
  for (let i = 0; i < data.length; i++) crc = (crc >>> 8) ^ crcT[(crc ^ data[i]) & 0xFF];
  return (crc ^ 0xFFFFFFFF) >>> 0;
}
function escapeXml(s) {
  return ('' + s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function colName(i) {
  let s = '', i2 = i;
  while (i2 >= 0) { s = String.fromCharCode(65 + (i2 % 26)) + s; i2 = Math.floor(i2 / 26) - 1; }
  return s;
}
function textWidth(s) {
  let w = 0;
  for (let i = 0; i < s.length; i++) {
    w += (s.charCodeAt(i) > 255) ? 2 : 1;
  }
  return w;
}
function sheetXml(headers, rows, title) {
  let xml = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';
  let colWidths = [];
  for (let c = 0; c < headers.length; c++) {
    let maxW = textWidth(headers[c]);
    for (let r = 0; r < rows.length; r++) {
      let w = textWidth('' + rows[r][c]);
      if (w > maxW) maxW = w;
    }
    colWidths.push(Math.max(10, maxW + 4));
  }
  xml += '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><cols>';
  for (let c = 0; c < colWidths.length; c++) {
    xml += '<col min="' + (c + 1) + '" max="' + (c + 1) + '" width="' + colWidths[c] + '" customWidth="1"/>';
  }
  xml += '</cols><sheetData>';
  let merges = [];
  let startRow = 1;
  if (title) {
    xml += '<row r="1" ht="24" customHeight="1"><c r="A1" s="1" t="inlineStr"><is><t>' + escapeXml(title) + '</t></is></c></row>';
    merges.push('<mergeCell ref="A1:' + colName(headers.length - 1) + '1"/>');
    startRow = 2;
  }
  xml += '<row r="' + startRow + '" ht="22" customHeight="1">';
  for (let c = 0; c < headers.length; c++) {
    xml += '<c r="' + colName(c) + startRow + '" s="1" t="inlineStr"><is><t>' + escapeXml(headers[c]) + '</t></is></c>';
  }
  xml += '</row>';
  for (let r = 0; r < rows.length; r++) {
    xml += '<row r="' + (r + startRow + 1) + '" ht="20" customHeight="1">';
    for (let c = 0; c < headers.length; c++) {
      let cell = rows[r][c];
      let ref = colName(c) + (r + startRow + 1);
      if (typeof cell === 'number') {
        xml += '<c r="' + ref + '" s="2"><v>' + cell + '</v></c>';
      } else {
        xml += '<c r="' + ref + '" s="2" t="inlineStr"><is><t>' + escapeXml(cell) + '</t></is></c>';
      }
    }
    xml += '</row>';
  }
  xml += '</sheetData>';
  if (merges.length > 0) xml += '<mergeCells count="' + merges.length + '">' + merges.join('') + '</mergeCells>';
  xml += '</worksheet>';
  return xml;
}
async function buildXlsxBlob(sheets) {
  const enc = new TextEncoder();
  const parts = [];
  parts.push(['[Content_Types].xml', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">' +
    '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>' +
    '<Default Extension="xml" ContentType="application/xml"/>' +
    '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>' +
    '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>' +
    sheets.map((s, i) => '<Override PartName="/xl/worksheets/sheet' + (i + 1) + '.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>').join('') +
    '</Types>')]);
  parts.push(['_rels/.rels', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>' +
    '</Relationships>')]);
  parts.push(['xl/workbook.xml', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">' +
    '<sheets>' +
    sheets.map((s, i) => '<sheet name="' + escapeXml(s.name) + '" sheetId="' + (i + 1) + '" r:id="rId' + (i + 1) + '"/>').join('') +
    '</sheets></workbook>')]);
  parts.push(['xl/_rels/workbook.xml.rels', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
    sheets.map((s, i) => '<Relationship Id="rId' + (i + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet' + (i + 1) + '.xml"/>').join('') +
    '<Relationship Id="rId' + (sheets.length + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>' +
    '</Relationships>')]);
  parts.push(['xl/styles.xml', enc.encode(
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
    '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
    '<numFmts count="0"/>' +
    '<fonts count="2"><font><sz val="11"/><name val="Calibri"/></font><font><b/><sz val="11"/><color rgb="FFFFFFFF"/><name val="Calibri"/></font></fonts>' +
    '<fills count="3"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor rgb="FF4472C4"/><bgColor indexed="64"/></patternFill></fill></fills>' +
    '<borders count="1"><border><left style="thin"><color auto="1"/></left><right style="thin"><color auto="1"/></right><top style="thin"><color auto="1"/></top><bottom style="thin"><color auto="1"/></bottom><diagonal/></border></borders>' +
    '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>' +
    '<cellXfs count="3"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/><xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1" applyBorder="1"/><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" applyBorder="1"/></cellXfs>' +
    '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>' +
    '</styleSheet>')]);
  sheets.forEach((s, i) => {
    parts.push(['xl/worksheets/sheet' + (i + 1) + '.xml', enc.encode(sheetXml(s.headers, s.data, s.title))]);
  });

  const entries = [];
  for (const [name, data] of parts) {
    const cs = new CompressionStream('deflate-raw');
    const writer = cs.writable.getWriter();
    writer.write(data);
    writer.close();
    const reader = cs.readable.getReader();
    const chunks = [];
    let total = 0;
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      chunks.push(value);
      total += value.length;
    }
    const comp = new Uint8Array(total);
    let off = 0;
    for (const c of chunks) { comp.set(c, off); off += c.length; }
    entries.push({ name, data, comp, crc: crc32(data) });
  }

  let offset = 0;
  const localParts = [];
  for (const e of entries) {
    const nameArr = new TextEncoder().encode(e.name);
    localParts.push({ e, nameArr, offset });
    offset += 30 + nameArr.length + e.comp.length;
  }

  const chunks = [];
  for (const { e, nameArr: name, offset } of localParts) {
    const lh = new DataView(new ArrayBuffer(30));
    lh.setUint32(0, 0x04034b50, true);
    lh.setUint16(4, 20, true);
    lh.setUint16(6, 0x0800, true);
    lh.setUint16(8, 8, true);
    lh.setUint32(14, e.crc, true);
    lh.setUint32(18, e.comp.length, true);
    lh.setUint32(22, e.data.length, true);
    lh.setUint16(26, name.length, true);
    lh.setUint16(28, 0, true);
    chunks.push(new Uint8Array(lh.buffer), name, e.comp);
  }
  const centralStart = offset;
  let centralSize = 0;
  for (const { e, nameArr: name, offset } of localParts) {
    const ch = new DataView(new ArrayBuffer(46));
    ch.setUint32(0, 0x02014b50, true);
    ch.setUint16(4, 20, true);
    ch.setUint16(6, 20, true);
    ch.setUint16(8, 0x0800, true);
    ch.setUint16(10, 8, true);
    ch.setUint32(16, e.crc, true);
    ch.setUint32(20, e.comp.length, true);
    ch.setUint32(24, e.data.length, true);
    ch.setUint16(28, name.length, true);
    ch.setUint16(30, 0, true);
    ch.setUint16(32, 0, true);
    ch.setUint16(34, 0, true);
    ch.setUint16(36, 0, true);
    ch.setUint32(38, 0, true);
    ch.setUint32(42, offset, true);
    chunks.push(new Uint8Array(ch.buffer), name);
    centralSize += 46 + name.length;
  }
  const eocd = new DataView(new ArrayBuffer(22));
  eocd.setUint32(0, 0x06054b50, true);
  eocd.setUint16(4, 0, true);
  eocd.setUint16(6, 0, true);
  eocd.setUint16(8, localParts.length, true);
  eocd.setUint16(10, localParts.length, true);
  eocd.setUint32(12, centralSize, true);
  eocd.setUint32(16, centralStart, true);
  eocd.setUint16(20, 0, true);
  chunks.push(new Uint8Array(eocd.buffer));
  return new Blob(chunks, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
}
function buildXlsxWorkbook(sheets, fileName) {
  buildXlsxBlob(sheets).then(blob => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  });
}

export default {
  buildXlsxWorkbook: buildXlsxWorkbook
}


// WEBPACK FOOTER //
// ./src/view/excel.js